import React from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { useIdCopy } from "@hooks/useIdCopy";
import { GLViewRow } from "../glViewTypes";
import { GL_COPY_LABEL } from "./glCellHelpers";

export const GLDescriptionCell = React.memo(function GLDescriptionCell({
    row,
}: CellContext<ViewTableFeatures, GLViewRow, unknown>): React.ReactElement {
    const { rowKind, transaction } = row.original;
    const { getCopyProps } = useIdCopy({ label: GL_COPY_LABEL });

    if (rowKind !== "transaction" || !transaction) {
        return <ViewTableCell />;
    }

    return (
        <ViewTableCell {...getCopyProps(transaction.referenceNumber)}>
            {transaction.bankDescription ?? transaction.description}
        </ViewTableCell>
    );
});
